/**
 * PERSISTENT LEFT INDEX RAIL // KEVIN ARTHUR DE LIMA
 * Displays active section drawing index and a vertical scroll-progress hairline.
 */

export function initRail(sections) {
  const container = document.getElementById('left-rail');
  if (!container) return;

  const totalSections = sections.length - 1; // Exclude hero if 00 to 06
  container.innerHTML = `
    <div class="rail-index">
      <span class="rail-num" id="rail-active-num">00</span>
      <span class="rail-total">/ 06</span>
    </div>
    <div class="rail-track">
      <div class="rail-progress" id="rail-progress-bar"></div>
      <div class="rail-marker" id="rail-marker-node"></div>
    </div>
    <div class="rail-callsign" id="rail-dwg-tag">DWG-000</div>
  `;

  const numEl = document.getElementById('rail-active-num');
  const barEl = document.getElementById('rail-progress-bar');
  const markerEl = document.getElementById('rail-marker-node');
  const dwgEl = document.getElementById('rail-dwg-tag');

  // Listen for custom section change events from scroll trigger
  document.addEventListener('sectionchange', e => {
    const { index, id } = e.detail;
    const padNum = String(index).padStart(2, '0');
    if (numEl) numEl.textContent = padNum;
    if (dwgEl) dwgEl.textContent = `DWG-${padNum}`;
  });

  // Track vertical page scroll percentage
  function updateScrollProgress() {
    const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = totalHeight > 0 ? (window.scrollY / totalHeight) * 100 : 0;
    const bounded = Math.min(100, Math.max(0, progress));

    if (barEl) barEl.style.height = `${bounded}%`;
    if (markerEl) markerEl.style.top = `${bounded}%`;
  }

  window.addEventListener('scroll', updateScrollProgress, { passive: true });
  updateScrollProgress();
}
